import { render, staticRenderFns } from "./UIInputFileNew.vue?vue&type=template&id=4a4c7680&"
import script from "./UIInputFileNew.vue?vue&type=script&lang=js&"
export * from "./UIInputFileNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports